import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ChecklistStepsComponent } from './checklist-steps.component';
import { ColorCircleModule } from 'ngx-color/circle';

const routes: Routes = [
  { path: '', component: ChecklistStepsComponent, data: { title: 'Checklist Categories' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes), ColorCircleModule],
  exports: [RouterModule],
})
export class ChecklistStepsRoutingModule {}

@NgModule({
  imports: [
    ChecklistStepsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ChecklistStepsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [ChecklistStepsComponent],
})
export class ChecklistStepsModule {}
